import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";

class Verification extends Component {
  constructor() {
    super();
    this.state = {
      id: null,
      success: null,
    };
  }

  getURI() {
    switch (this.props.match.params.type) {
      case "1":
        return "/crop/companyagentverification";
      case "2":
        return "/crop/approveuser";
      case "3":
        return "/crop/approvebrand";
      default:
        return "";
    }
  }

  componentWillMount() {
    var data = { verification_string: this.props.match.params.id };
    axios
      .post(this.getURI(), JSON.stringify(data), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        this.setState({ success: true });
      })
      .catch((response) => {
        this.setState({ success: false });
      });
  }

  render() {
    return (
      <div className="About">
        <div className="about-box">
          {this.state.success === null ? null : (
            <h1 className="terms-title">
              {this.state.success
                ? "Verification Successful!"
                : "Failed to verify user"}
            </h1>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(Verification);



// WEBPACK FOOTER //
// ./src/containers/Verification.js